"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.novasolImageSizes = exports.defaultImageSizes = void 0;
exports.defaultImageSizes = [
    840, 840, 1200, 1200,
];
exports.novasolImageSizes = [
    600, 600, 1024, 1024,
];
//# sourceMappingURL=imageSizes.js.map